export default __webpack_public_path__ + "static/media/CoinDeactive.077ba277.svg";